import { useEffect } from "react";
import { Div, TituloGroup } from "../../Styles/Styled";
import { Colors, VIEW_GRUPO2 } from "../../config";
import Products from "../Products";

interface Item {
  chave: number;
  descricao: string;
  preco_venda: number;
  grupo1: string;
  grupo2: string;
  grupo3: string;
  unidade: string;
  picture: string;
  observacao: string;
  tipo: string;
}

interface IContainerProds {
  items: Item[];
  groups: string[];
  groupsnv2: any;
  perRow: number;
}

export default function ContainerProds(props: IContainerProds) {
  const width = window.innerWidth - 20;

  const renderGrupoNv2 = (group2: string, group: string) => {
    return (
      <>
        <TituloGroup id={group2}>{group2}</TituloGroup>
        <Div
          row={true}
          Wrap={true}
          Items="center"
          Content="center"
          Margin={{
            bottom: "10px",
            top: "10px",
          }}
        >
          {props.items
            .filter((e) => e.grupo1 === group && e.grupo2 === group2)
            .map((item) => {
              return (
                <Products
                  {...item}
                  width={
                    width / props.perRow < 400 ? 320 : width / props.perRow
                  }
                />
              );
            })}
        </Div>
      </>
    );
  };

  const renderGrupo2 = (groupSelect: string) => {
    console.log(props.groupsnv2[groupSelect], "group2");
    if (groupSelect) {
      if (!props.groupsnv2[groupSelect]) return undefined;
      if (!props.groupsnv2[groupSelect][0]) {
        return undefined;
      }
      console.log("passo", groupSelect);
      return props.groupsnv2[groupSelect].map((e: any, len: number) =>
        renderGrupoNv2(e, groupSelect)
      );
    } else {
      return undefined;
    }
  };

  useEffect(() => {
    console.log(props.groups, VIEW_GRUPO2);
  }, []);

  return (
    <Div id="Produtos">
      {props.groups.map((group) => {
        return (
          <Div background={Colors.backgroundColorApp}>
            <TituloGroup
              id={group}
              style={
                VIEW_GRUPO2 && props.groupsnv2[group][0]
                  ? { color: Colors.backgroundHeader, marginBottom: -20 }
                  : {}
              }
            >
              {group}
            </TituloGroup>
            <Div
              row={true}
              Wrap={true}
              Items="center"
              Content="center"
              Margin={{
                bottom: "10px",
                top: "10px",
              }}
            >
              {props.items
                .filter((e) => {
                  return VIEW_GRUPO2
                    ? e.grupo1 === group && !e.grupo2
                    : e.grupo1 === group;
                })
                .map((item) => {
                  return (
                    <Products
                      {...item}
                      width={
                        width / props.perRow < 400 ? 320 : width / props.perRow
                      }
                    />
                  );
                })}
            </Div>
            {VIEW_GRUPO2 && renderGrupo2(group)}
          </Div>
        );
      })}
    </Div>
  );
}
